/** RTE-X11.4e — global itinerary editor panel (feature-flagged). */

let itineraryFlagLogged = false;

/**
 * When unset: OFF in production, ON in development.
 * REACT_APP_SEQUENTIAL_STOPS_ITINERARY_EDITOR=true|false
 */
export function isSequentialStopsItineraryEditorEnabled(): boolean {
  const raw = process.env.REACT_APP_SEQUENTIAL_STOPS_ITINERARY_EDITOR;
  let enabled: boolean;
  if (raw === undefined || raw === '') {
    enabled = process.env.NODE_ENV === 'development';
  } else {
    enabled = String(raw).toLowerCase() === 'true';
  }
  if (process.env.NODE_ENV === 'development' && !itineraryFlagLogged) {
    itineraryFlagLogged = true;
    // eslint-disable-next-line no-console
    console.debug(
      '[SequentialStopsItinerary] REACT_APP_SEQUENTIAL_STOPS_ITINERARY_EDITOR =',
      raw,
      '| enabled =',
      enabled
    );
  }
  return enabled;
}

export function isSequentialStopsItineraryShadowDebugEnabled(): boolean {
  return process.env.REACT_APP_SEQUENTIAL_STOPS_ITINERARY_SHADOW_DEBUG === 'true';
}
